// @core/api/endpoints/form/delete_form_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/form';

/**
 * Delete form policy
 * Deletes a form policy. Scope entities will fall through to the next ancestor policy.
 */
export async function DeleteFormPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/form-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
